import { HierarchyContextProps } from "./interface";

export const hierarchyInitialState: HierarchyContextProps = {
  id: "",
  accessRights: [],
  changed: false,
  hierarchyNodes: [],
  parentTemplates: {
    clinicalDatasets: [],
    clinicalCodeLists: [],
    clinicalValueLists: [],
    clinicalComments: [],
    clinicalMethods: [],
    clinicalWhereClauses: [],
    domainReplacements: [],
    lists: [],
    rowGroups: [],
    singles: [],
    analysisSets: [],
    analysisMethods: [],
    dataSubsets: [],
    groupingFactors: [],
  },
  prefix: "",
  commentPanelStatus: {
    highlightCommentId: "",
    activeRelatedTo: "",
    showComments: false,
    commentFilter: "all",
  },
  doGetAccessRights: false,
  doSave: false,
  doTocSave: false,
  hierarchy: null,
  isClinicalLibraryLoading: false,
  isSubscribed: false,
  saveRequestStatus: { requesting: false, error: false },
  saveTocRequestStatus: { requesting: false, error: false },
  savedHierarchy: null,
  tlfItemIndex: null,
  isNameChanged: false,
};
